import { Link, useLocation } from "react-router-dom";

/**
 * Catch-all for paths no route matches (a typo, `/run/<id>` for `/runs/<id>`,
 * a bookmark from an older layout). Without it the router renders nothing and
 * the operator sees the nav over a blank page with no hint why.
 */
export function NotFound() {
  const { pathname } = useLocation();
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginTop: 0 }}>Page not found</h2>
      <p style={{ color: "var(--muted)" }}>
        Nothing lives at <code>{pathname}</code>.{" "}
        <Link to="/">Back to Live</Link> or browse <Link to="/runs">Runs</Link>.
      </p>
    </div>
  );
}
